var map = {
	"./Aktuelles/1_Platz_PH2_Winter2024.jpg": 510,
	"./Aktuelles/3 Platz Rglt Hambach.jpg": 586,
	"./Aktuelles/A Mannschaft VR2024.jpg": 958,
	"./Aktuelles/Krebs30032025.jpg": 626,
	"./Aktuelles/MeisterVRHerbst2024.jpg": 747,
	"./BildTurnhalle.jpeg": 732,
	"./Fahne.png": 822,
	"./Logo.png": 986,
	"./Logo_alt.png": 373,
	"./Open1.jpg": 400,
	"./Open2.jpg": 331,
	"./Open3.jpg": 809,
	"./Open4.jpg": 64,
	"./Rueckblick/Jugend_Werntalcup_2023.jpg": 306,
	"./Rueckblick/Rueckblick1.jpg": 533,
	"./Rueckblick/Rueckblick2.jpg": 952,
	"./Rueckblick/Rueckblick3.jpg": 410,
	"./Rueckblick/Rueckblick4.jpg": 368,
	"./Rueckblick/RückblickTTLangendorf.jpg": 588,
	"./Rueckblick/Spielstandam07102023.jpg": 152,
	"./Rueckblick/TTBLKönigshofen 25112023.jpg": 824,
	"./TSVPoppenhausenLogo.jpeg": 820,
	"./TSVWappenkd.jpg": 1,
	"./tt_banner_header_new.png": 413
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 226;